"use strict";

exports.__esModule = true;
exports.default = void 0;

var _ctaOfferType = require("./offer/ctaOfferType");

var Cof = _interopRequireWildcard(require("./offer/ctaOfferFormula"));

var Check10 = _interopRequireWildcard(require("./offer/check10"));

var Check10a = _interopRequireWildcard(require("./offer/check10a"));

var Check10b = _interopRequireWildcard(require("./offer/check10b"));

var Check10c = _interopRequireWildcard(require("./offer/check10c"));

var Check10d = _interopRequireWildcard(require("./offer/check10d"));

var Check10dbis = _interopRequireWildcard(require("./offer/check10dbis"));

var Check10e = _interopRequireWildcard(require("./offer/check10e"));

var Check20 = _interopRequireWildcard(require("./offer/check20"));

var Check30 = _interopRequireWildcard(require("./offer/check30"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const placeholder = content => ({
  eventlabel: content,
  eventcategory: 'placeholder',
  eventtype: 'test'
});

var _default = {
  showCot: _ctaOfferType.showCot,
  chooseCotItem: _ctaOfferType.chooseCotItem,
  clickCotItem: _ctaOfferType.clickCotItem,
  clickCotNeedHelp: _ctaOfferType.clickCotNeedHelp,
  clickCotAlreadySubscriber: _ctaOfferType.clickCotAlreadySubscriber,
  clickCotOtherOfferType: _ctaOfferType.clickCotOtherOfferType,
  clickCotFaqMoreInfo: _ctaOfferType.clickCotFaqMoreInfo,
  clickCotFaqItem: _ctaOfferType.clickCotFaqItem,
  clickCotCustomerSupport: _ctaOfferType.clickCotCustomerSupport,
  Cof,
  Check10,
  Check10a,
  Check10b,
  Check10c,
  Check10d,
  Check10dbis,
  Check10e,
  Check20,
  Check30,
  placeholder
};
exports.default = _default;